import type { SubmissionFilters } from '@/api/submissions';

export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  orgs: {
    all: ['orgs'] as const,
    detail: (id: string) => ['orgs', id] as const,
    members: (orgId: string) => ['orgs', orgId, 'members'] as const,
    invitations: (orgId: string) => ['orgs', orgId, 'invitations'] as const,
  },
  forms: {
    all: ['forms'] as const,
    detail: (id: string) => ['forms', id] as const,
  },
  submissions: {
    list: (formId: string, filters?: SubmissionFilters) => ['submissions', formId, filters] as const,
    detail: (formId: string, id: string) => ['submissions', formId, id] as const,
  },
  analytics: {
    trends: (formId: string, period: string) => ['analytics', 'trends', formId, period] as const,
    referrers: (formId: string) => ['analytics', 'referrers', formId] as const,
    completions: (formId: string) => ['analytics', 'completions', formId] as const,
  },
  billing: {
    plan: (orgId: string) => ['billing', orgId] as const,
    usage: (orgId: string) => ['billing', 'usage', orgId] as const,
  },
} as const;
